import { deleteWareHouse, findWareHousesByName, getAllWareHouses } from "../../../actions/wareHouseActions";
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Translate } from '../../../../language';
import { Link } from 'react-router-dom'
import CardList from "../../../../utils/components/CardList/CardList";
import Button from "../../../../utils/components/Button/Button";
import "./WareHause.css";
import useModal from "../../../../utils/hooks/useModal";
import { Field, Form, Formik } from "formik";
import Warehouses from "../../../containers/Warehouses/Warehouses/Warehouses";

export const WarehouseAdmin = ({ history }) => {
    const dispatch = useDispatch();
    const { wareHouseList } = useSelector((state) => state.WareHouse);
    const [wareHouse, setWareHause] = useState(null);
    useEffect(() => {
        dispatch(findWareHousesByName(""))
    }, [])
    return <Warehouses searchAction={value => { dispatch(findWareHousesByName(value)) }} listWarehouses={wareHouseList}
        wareHouse={wareHouse} setWareHouse={setWareHause}
    />
}

const Modal = ({ closeModal, displayModal, wareHause }) => {
    const divStyle = {
        display: displayModal ? 'block' : 'none'
    }
    const close = (e) => {
        closeModal(false)
    }
    //const ref = useRef(null)
    const dispatch = useDispatch();
    if (!wareHause) {
        return <></>
    }
    return <div
        className={"modal"}
        style={divStyle}
        onClick={close}>
        <div
            className="modal-content modal-content-new-post"
            onClick={e => e.stopPropagation()} >
            <div className="text-input-admin">
                desea borrar el almacen: {wareHause.name}
            </div>
            <div className="content-buttom-create">
                <button type='button' onClick={(e) => { close(e) }} className={`btns-admin btn-create-edit btns-admin-inactive`}>{Translate('cancel', 'es')}</button>
                <button type='submit'
                    onClick={(e) => {
                        close(e)
                        dispatch(deleteWareHouse(wareHause._id))
                    }}
                    className={`btns-admin btn-create-edit btns-admin-inactive`}>{Translate('delete', 'es')}</button>
            </div>
        </div>
    </div>
}